// @flow
import i18n from './i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/hu';

export function getLanguage() {
	return i18n.language.substr(0, 2);
}

export async function setLanguage(languageCode: string) {
	dayjs.locale(languageCode);
	await i18n.changeLanguage(languageCode);
}
